
import Vue from 'vue';
import VueI18n from 'vue-i18n';
import Cookies from 'js-cookie';
import en from '@/locales/en.js';
import zh from '@/locales/zh-CN.js';
import fr from '@/locales/fr.js';
import th from '@/locales/th.js';
import lao from '@/locales/lao.js';
import es from '@/locales/es.js';

Vue.use(VueI18n);

const messages = {
  'en': en,
  'zh-CN': zh,
  'fr': fr,
  'th': th,
  'lao': lao,
  'es': es
};

const i18n = new VueI18n({
  locale: Cookies.get('locale') && Cookies.get('locale') == 1 ? 'zh-CN' : 'es', // 从 cookie 中获取语言，否则默认为 'es'
  fallbackLocale: 'es',
  messages,
});

export default i18n;
